import React, {useState} from "react";
import {Popup, PopupBody, PopupFooter, PopupHeader, PopupTitle} from "../../component/Popup/Popup";

export default function AddPartenairePopup(props) {
    const [partner, setPartner] = useState({Title: "",
                                            picture: [],
                                            Site: ""});
    const [error, setError] = useState("");
    const specialCharacter = new RegExp("[`!@#$%^&*()+\\\=\\\[\\\]{};:\\\"\\\\|,.<>\\\/?~]");

    function buildCard() {
        return (<div className={"col-4 pt-3"}>
            <div className={"card text-center"}>
                <img src={URL.createObjectURL(partner.picture)}
                     className={"img-thumbnail cursor-pointer "} alt="..."/>
            </div>
        </div>);
    };

    function buildImagePreview() {
        return (<div className={"row"}>{buildCard()}</div>);
    };

    function handleSubmit() {
        if (partner.Title === "")
            return;
        props.add(partner);
    };

    return (<Popup size={"large"} close={props.close}>
        <PopupHeader>
            <PopupTitle>Créer un nouveau partenaire</PopupTitle>
        </PopupHeader>

        <PopupBody>
            <div className={"form-container"}>
                <label className={"text-left"}>Nom du partenaire<i
                    className={"text-danger"}> *</i></label>
                <input className="form-control" type={"text"} placeholder={""}
                       value={partner.Title} onChange={(event) => {
                    let tmpPartner = partner;
                    tmpPartner.Title = event.target.value;
                    setPartner(tmpPartner);
                }}/>
                {!partner.Title &&
                <small className={"text-danger col-12"}>Ce champ est obligatoire</small>}
            </div>

            <div className={"form-container"}>
                <label className={"text-left"}>Site du partenaire</label>
                <input className="form-control" type={"text"} placeholder={""}
                       value={partner.Site} onChange={(event) => {
                    let tmpPartner = partner;
                    tmpPartner.Site = event.target.value;
                    setPartner(tmpPartner);
                }}/>
            </div>

            <div className={"w-100 text-center row horizontal-top-line-grey-dark"}>
                <h6 className={"w-100"}>Photo</h6>
                <input accept=".png, .jpg" type={"file"} className={"input-image col text-center"}
                       onChange={(event) => {
                           var tmpPartner = partner;
                           tmpPartner.picture = event.target.files[0];
                           setPartner(tmpPartner);
                       }}/>
            </div>

            {partner.picture.length !== 0 &&
            buildImagePreview()
            }
        </PopupBody>

        <PopupFooter dismiss={"Annuler"} close={props.close}>
            <input className={"btn btn-primary"} type={"submit"} value={"Créer"}
                   onClick={() => handleSubmit()}/>
        </PopupFooter>
    </Popup>);
}